import React from 'react'
import './info-card.sass';

export interface InfoCardData {
    title: string,
    number: number,
}

export const InfoCard = (props: InfoCardData) => {
    const { title, number } = props
    return (
        <>
            <div className="col-lg-4 col-md-4 col-sm-12 mb-lg-0 mb-md-0 mb-3">
                <div className="info-card">
                    <h5 className='heading-new-5 mb-3'>{title || 0}</h5>
                    <h2 className='heading-new-2 mb-0'>{number || 0}</h2>
                </div>
            </div>
        </>
    )
}
